import React from 'react';

import AgModalWindow from '../../src/components/common/ModalWindow/AgModalWindow';
import Button, { ButtonStyleType } from '../../src/components/common/Button/Button';
import styles from './reload-app-modal.module.scss';

export interface ReloadAppModalProps {
  onClose: () => void
}

export default function ReloadAppModal({onClose}: ReloadAppModalProps) {
  return (
    <AgModalWindow
        title="Application Updated"
        contentStyle={{ width: 550 }}
        isOpen={true}
        onClose={onClose}
      >
        <div className={styles.reload}>
          <div className={styles.message}>
            <span>A new version of the app has been released!</span>
            <span>The application will reload with the new version.</span>
            <span>Unsaved changes will be lost.</span>
          </div>
          <Button
            buttonStyleType={ButtonStyleType.PRIMARY}
            className={styles.confirmation}
            onClick={onClose}
          >
            OK
          </Button>
        </div>
    </AgModalWindow>
  )
}